// modules
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// selectors
import { noInternetConnection$ } from 'src/store/modules/ui'

// actions
import { setNoInternetConnection } from 'src/store/modules/actionCreators'

// components
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'

const mapStateToProps = (state) => ({
  noInternetConnection: noInternetConnection$(state)
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setNoInternetConnection
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ErrorBoundary))
